export interface IconProps {
  className?: string;
}

export function SeedIcon({ className }: IconProps) {
  return (
    <svg className={className} width="28" height="40" viewBox="0 0 28 40" fill="none" aria-hidden="true">
      <path d="M14 4 C9 8 6 16 7 24 C8 30 11 35 14 37 C17 35 20 30 21 24 C22 16 19 8 14 4Z" fill="url(#seedBody)" />
      <path d="M14 4 C9 8 6 16 7 24 C8 30 11 35 14 37 C17 35 20 30 21 24 C22 16 19 8 14 4Z" fill="none" stroke="rgba(140,115,70,0.5)" strokeWidth="0.7" />
      <path d="M14 6 C14 14 14 24 14 36" stroke="rgba(130,105,60,0.4)" strokeWidth="0.8" fill="none" />
      <path d="M14 12 C11.5 14 9 18 8 22" stroke="rgba(130,105,60,0.2)" strokeWidth="0.5" fill="none" />
      <path d="M14 12 C16.5 14 19 18 20 22" stroke="rgba(130,105,60,0.2)" strokeWidth="0.5" fill="none" />
      <path d="M14 20 C12 22 10 26 9 30" stroke="rgba(130,105,60,0.15)" strokeWidth="0.4" fill="none" />
      <path d="M14 20 C16 22 18 26 19 30" stroke="rgba(130,105,60,0.15)" strokeWidth="0.4" fill="none" />
      <ellipse cx="12" cy="14" rx="2.5" ry="3" fill="rgba(235,215,165,0.18)" />
      <defs>
        <radialGradient id="seedBody" cx="38%" cy="35%" r="60%">
          <stop offset="0%" stopColor="rgba(225,200,150,0.95)" />
          <stop offset="45%" stopColor="rgba(200,175,125,0.92)" />
          <stop offset="100%" stopColor="rgba(165,140,95,0.88)" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function SproutIcon({ className }: IconProps) {
  return (
    <svg className={className} width="44" height="52" viewBox="0 0 44 52" fill="none" aria-hidden="true">
      <path d="M22 44 C17 44 14 41 14 37 C14 33 16.5 31 22 30 C27.5 31 30 33 30 37 C30 41 27 44 22 44Z" fill="url(#sproutSeed2)" stroke="rgba(160,130,80,0.3)" strokeWidth="0.5" />
      <path d="M22 31 C22 26 22 22 22 14" stroke="rgba(120,100,60,0.55)" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M22 22 C16 18 12 13 14 9 C15 7 18 7 20 9 C22 12 22 16 22 20" fill="url(#sproutLeafL)" />
      <path d="M22 22 C16 18 12 13 14 9" fill="none" stroke="rgba(50,130,70,0.35)" strokeWidth="0.5" />
      <path d="M18 13 C17 15 17.5 17 19 19" stroke="rgba(50,130,70,0.25)" strokeWidth="0.4" fill="none" />
      <path d="M22 17 C28 13 32 8 30 5 C29 3.5 26 4 24 6 C22 9 22 13 22 16" fill="url(#sproutLeafR)" />
      <path d="M22 17 C28 13 32 8 30 5" fill="none" stroke="rgba(50,130,70,0.35)" strokeWidth="0.5" />
      <path d="M27 9 C26.5 11 26 13 24.5 15" stroke="rgba(50,130,70,0.25)" strokeWidth="0.4" fill="none" />
      <path d="M22 26 C19 24 16 22 15 19" fill="url(#sproutLeafS)" />
      <defs>
        <radialGradient id="sproutSeed2" cx="45%" cy="42%" r="55%">
          <stop offset="0%" stopColor="rgba(200,175,120,0.85)" />
          <stop offset="100%" stopColor="rgba(160,135,85,0.75)" />
        </radialGradient>
        <linearGradient id="sproutLeafL" x1="0.2" y1="0" x2="0.8" y2="1">
          <stop offset="0%" stopColor="rgba(120,210,140,0.9)" />
          <stop offset="100%" stopColor="rgba(80,180,100,0.8)" />
        </linearGradient>
        <linearGradient id="sproutLeafR" x1="0.8" y1="0" x2="0.2" y2="1">
          <stop offset="0%" stopColor="rgba(110,200,130,0.88)" />
          <stop offset="100%" stopColor="rgba(70,170,90,0.78)" />
        </linearGradient>
        <linearGradient id="sproutLeafS" x1="0.3" y1="0" x2="0.7" y2="1">
          <stop offset="0%" stopColor="rgba(100,190,120,0.7)" />
          <stop offset="100%" stopColor="rgba(65,160,85,0.5)" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function LeafIcon({ className }: IconProps) {
  return (
    <svg className={className} width="52" height="60" viewBox="0 0 52 60" fill="none" aria-hidden="true">
      <path d="M24 56 Q18 48 10 38 C4 30 2 20 8 12 C12 6 20 4 28 6 C36 8 44 14 46 24 C48 34 42 44 34 52 Q30 56 26 58Z" fill="url(#leafBody)" />
      <path d="M24 56 Q18 48 10 38 C4 30 2 20 8 12 C12 6 20 4 28 6 C36 8 44 14 46 24 C48 34 42 44 34 52 Q30 56 26 58Z" fill="none" stroke="rgba(35,100,55,0.45)" strokeWidth="0.8" />
      <path d="M16 10 Q21 26 25 56" stroke="rgba(35,105,55,0.7)" strokeWidth="1.6" strokeLinecap="round" fill="none" />
      <path d="M14 14 C11 17 8 22 6 27" stroke="rgba(35,105,55,0.55)" strokeWidth="1.1" strokeLinecap="round" fill="none" />
      <path d="M16 21 C12 24 9 29 7 34" stroke="rgba(35,105,55,0.5)" strokeWidth="1" strokeLinecap="round" fill="none" />
      <path d="M18 28 C15 31 12 35 10 40" stroke="rgba(35,105,55,0.45)" strokeWidth="0.9" strokeLinecap="round" fill="none" />
      <path d="M20 35 C17 38 15 42 13 46" stroke="rgba(35,105,55,0.4)" strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M22 42 C20 44 18 47 17 50" stroke="rgba(35,105,55,0.35)" strokeWidth="0.7" strokeLinecap="round" fill="none" />
      <path d="M19 14 C24 12 30 12 36 14" stroke="rgba(35,105,55,0.55)" strokeWidth="1.1" strokeLinecap="round" fill="none" />
      <path d="M20 21 C26 19 32 20 38 23" stroke="rgba(35,105,55,0.5)" strokeWidth="1" strokeLinecap="round" fill="none" />
      <path d="M22 28 C27 27 33 28 39 31" stroke="rgba(35,105,55,0.45)" strokeWidth="0.9" strokeLinecap="round" fill="none" />
      <path d="M23 35 C28 34 34 35 39 38" stroke="rgba(35,105,55,0.4)" strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M24 42 C28 41 33 42 37 44" stroke="rgba(35,105,55,0.35)" strokeWidth="0.7" strokeLinecap="round" fill="none" />
      <defs>
        <radialGradient id="leafBody" cx="35%" cy="30%" r="65%">
          <stop offset="0%" stopColor="rgba(130,220,155,0.95)" />
          <stop offset="40%" stopColor="rgba(90,195,120,0.92)" />
          <stop offset="75%" stopColor="rgba(65,170,95,0.88)" />
          <stop offset="100%" stopColor="rgba(45,140,70,0.85)" />
        </radialGradient>
      </defs>
    </svg>
  );
}
